import { render, staticRenderFns } from "./TplMultitables.vue?vue&type=template&id=c01faa3a&scoped=true&"
import script from "./TplMultitables.vue?vue&type=script&lang=js&"
export * from "./TplMultitables.vue?vue&type=script&lang=js&"
import style0 from "./TplMultitables.vue?vue&type=style&index=0&id=c01faa3a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01faa3a",
  null
  
)

export default component.exports